export const FLOW_V2_INCLUDE_WELCOME_SCREEN = 'Include Welcome Screen FLOW_V2';
export const FLOW_V2_WELCOME_SCREEN_HEADING = 'Welcome Screen Heading';
export const FLOW_V2_WELCOME_SCREEN_BODY = 'Welcome Screen Body';
export const FLOW_V2_WELCOME_SCREEN_FOOTER = 'Welcome Screen Footer';
export const FLOW_V2_WELCOME_SCREEN_BUTTON = 'Welcome Screen Button';
